import React from "react";
import { clsx } from "clsx";

interface ProductSwatch {
  url: string;
  name: string;
  image?: string;
  color?: string;
  is_product: boolean;
  show_name?: boolean;
}

interface ProductSwatchesProps {
  productSwatches: ProductSwatch[];
  currentSwatchProduct: string | null;
  handleSwatchClick: (e: React.MouseEvent, swatch: ProductSwatch) => void;
  handleSwatchHover: (swatch: ProductSwatch) => void;
  handleSwatchLeave: () => void;
  className?: string;
}

const ProductSwatches: React.FC<ProductSwatchesProps> = ({
  productSwatches,
  currentSwatchProduct,
  handleSwatchClick,
  handleSwatchHover,
  handleSwatchLeave,
  className,
}) => {
  if (!productSwatches.length) return null;

  return (
    <div className={clsx("product__swatches", className)} data-react-swatches="true">
      {productSwatches.map((swatch, index) => {
        const swatchProductHandle = swatch.url.split("/").pop()?.split("?")[0];
        const isCurrentlySelected =
          currentSwatchProduct === swatchProductHandle ||
          (swatch.is_product && !currentSwatchProduct);

        return (
          <div
            key={`${swatch.url}-${index}`}
            className={clsx("inline-block", {
              "border-b-2 border-[#54565A]": isCurrentlySelected,
            })}
          >
            <button
              type="button"
              className="product__swatch h-[16px] w-[16px] mb-[2px] cursor-pointer transition-all duration-200 hover:opacity-70 hover:scale-110 z-10 border-none bg-transparent p-0"
              onClick={(e) => handleSwatchClick(e, swatch)}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onMouseEnter={() => handleSwatchHover(swatch)}
              onMouseLeave={handleSwatchLeave}
              title={`View ${swatch.name || "variant"}`}
              style={{ pointerEvents: "auto" }}
              data-swatch-handle={swatchProductHandle}
            >
              {swatch.color && (
                <div className="mb-[2px] pointer-events-none">
                  <div
                    className="pointer-events-none product__swatch_color"
                    style={{ backgroundColor: swatch.color }}
                  />
                </div>
              )}
              {swatch.image && (
                <div className="h-[16px] w-[16px] mb-[2px] cursor-pointer pointer-events-none">
                  <img
                    className="object-cover w-full h-full pointer-events-none product__swatch_image"
                    src={swatch.image}
                    alt={swatch.name}
                    loading="lazy"
                  />
                </div>
              )}
              {swatch.show_name && swatch.name}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ProductSwatches;
